export default __webpack_public_path__ + "static/media/close-file.6d93f36c.svg";